import resultTexts from '../data/resultTexts';

const getResultText = (score: number, usedBus: boolean) => {
  let text = '';
  let resultTitle = '';
  resultTexts.forEach((resultText) => {
    if (between(score, resultText.range.min, resultText.range.max)) {
      if (usedBus) {
        text = resultText.usedBusText;
      } else {
        text = resultText.text;
      }
      resultTitle = resultText.resultTitle;
    }
  });
  return { text, resultTitle };
};

const between = (x: number, min: number, max: number) => {
  return x >= min && x <= max;
};

export default getResultText;
